import React, { useState } from "react";
import Swal from "sweetalert2";
import api from "../api/axios";

function DogRegistration() {
  const [formData, setFormData] = useState({
    ownerName: "",
    fatherHusbandName: "",
    mobileNo: "",
    email: "",
    address: "",
    wardNo: "",
    zone: "",
    pincode: "",

    dogName: "",
    breed: "",
    gender: "",
    dateOfBirth: "",
    age: "",
    color: "",
    identificationMark: "",
    microchipNo: "",

    rabiesVaccinated: "",
    vaccinationDate: "",
    certificateNo: "",
    nextVaccinationDate: "",

    registrationDate: new Date().toISOString().split("T")[0],
    sterilized: "",
    purpose: "",

    ownerIdProof: null,
    vaccinationCertificate: null,
    dogPhoto: null,

    declaration: false,
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]:
        type === "checkbox"
          ? checked
          : type === "file"
          ? files[0]
          : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.ownerName.trim()) {
      Swal.fire("Validation", "Please enter owner name.", "warning");
      return;
    }

    if (!formData.mobileNo.trim()) {
      Swal.fire("Validation", "Please enter mobile number.", "warning");
      return;
    }

    if (!formData.dogName.trim()) {
      Swal.fire("Validation", "Please enter dog name.", "warning");
      return;
    }

    if (!formData.breed) {
      Swal.fire("Validation", "Please select dog breed.", "warning");
      return;
    }

    if (!formData.gender) {
      Swal.fire("Validation", "Please select dog gender.", "warning");
      return;
    }

    if (!formData.address.trim()) {
      Swal.fire("Validation", "Please enter owner address.", "warning");
      return;
    }

    if (!formData.declaration) {
      Swal.fire(
        "Declaration Required",
        "Please accept the declaration.",
        "warning"
      );
      return;
    }

    try {
      setLoading(true);

      // API integration
      const form = new FormData();

      Object.keys(formData).forEach((key) => {
        if (formData[key] !== null) {
          form.append(key, formData[key]);
        }
      });

       await api.post("/DogRegistration/Register", form);

      console.log("Dog Registration Data:", formData);

      await new Promise((resolve) => setTimeout(resolve, 700));

      Swal.fire({
        icon: "success",
        title: "Registration Successful",
        text: "Dog registration submitted successfully.",
      });

      handleReset();
    } catch (error) {
      console.error(error);

      Swal.fire(
        "Error",
        "Unable to submit dog registration.",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  const handleReset = () => {
    setFormData({
      ownerName: "",
      fatherHusbandName: "",
      mobileNo: "",
      email: "",
      address: "",
      wardNo: "",
      zone: "",
      pincode: "",

      dogName: "",
      breed: "",
      gender: "",
      dateOfBirth: "",
      age: "",
      color: "",
      identificationMark: "",
      microchipNo: "",

      rabiesVaccinated: "",
      vaccinationDate: "",
      certificateNo: "",
      nextVaccinationDate: "",

      registrationDate: new Date().toISOString().split("T")[0],
      sterilized: "",
      purpose: "",

      ownerIdProof: null,
      vaccinationCertificate: null,
      dogPhoto: null,

      declaration: false,
    });

    document
      .querySelectorAll('input[type="file"]')
      .forEach((input) => (input.value = ""));
  };

  return (
    <div className="container-fluid py-4">

      {/* Page Header */}
      <div className="card shadow-sm border-0 mb-4">
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <h3 className="mb-1">
                <i className="bi bi-heart me-2"></i>
                Dog Registration
              </h3>
              <p className="text-muted mb-0">
                Register your pet dog with the municipal authority
              </p>
            </div>

            <span className="badge bg-primary fs-6">
              New Registration
            </span>
          </div>
        </div>
      </div>

      <form onSubmit={handleSubmit}>

        {/* Owner Details */}
        <div className="card shadow-sm border-0 mb-4">
          <div className="card-header bg-primary text-white">
            <h5 className="mb-0">
              <i className="bi bi-person me-2"></i>
              Owner Details
            </h5>
          </div>

          <div className="card-body">
            <div className="row g-3">

              <div className="col-md-4">
                <label className="form-label">
                  Owner Name <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="ownerName"
                  className="form-control"
                  value={formData.ownerName}
                  onChange={handleChange}
                  placeholder="Enter owner name"
                />
              </div>

              <div className="col-md-4">
                <label className="form-label">
                  Father / Husband Name
                </label>
                <input
                  type="text"
                  name="fatherHusbandName"
                  className="form-control"
                  value={formData.fatherHusbandName}
                  onChange={handleChange}
                  placeholder="Enter father / husband name"
                />
              </div>

              <div className="col-md-4">
                <label className="form-label">
                  Mobile No. <span className="text-danger">*</span>
                </label>
                <input
                  type="tel"
                  name="mobileNo"
                  className="form-control"
                  maxLength="10"
                  value={formData.mobileNo}
                  onChange={handleChange}
                  placeholder="10 digit mobile number"
                />
              </div>

              <div className="col-md-4">
                <label className="form-label">Email</label>
                <input
                  type="email"
                  name="email"
                  className="form-control"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Enter email"
                />
              </div>

              <div className="col-md-8">
                <label className="form-label">
                  Address <span className="text-danger">*</span>
                </label>
                <textarea
                  name="address"
                  className="form-control"
                  rows="2"
                  value={formData.address}
                  onChange={handleChange}
                  placeholder="Enter complete address"
                ></textarea>
              </div>

              <div className="col-md-4">
                <label className="form-label">Zone</label>
                <select
                  name="zone"
                  className="form-select"
                  value={formData.zone}
                  onChange={handleChange}
                >
                  <option value="">Select Zone</option>
                  <option value="Zone 1">Zone 1</option>
                  <option value="Zone 2">Zone 2</option>
                  <option value="Zone 3">Zone 3</option>
                  <option value="Zone 4">Zone 4</option>
                </select>
              </div>

              <div className="col-md-4">
                <label className="form-label">Ward No.</label>
                <select
                  name="wardNo"
                  className="form-select"
                  value={formData.wardNo}
                  onChange={handleChange}
                >
                  <option value="">Select Ward</option>
                  {Array.from({ length: 50 }, (_, i) => (
                    <option key={i + 1} value={i + 1}>
                      Ward {i + 1}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-md-4">
                <label className="form-label">Pincode</label>
                <input
                  type="text"
                  name="pincode"
                  className="form-control"
                  maxLength="6"
                  value={formData.pincode}
                  onChange={handleChange}
                  placeholder="Enter pincode"
                />
              </div>

            </div>
          </div>
        </div>

        {/* Dog Details */}
        <div className="card shadow-sm border-0 mb-4">
          <div className="card-header bg-success text-white">
            <h5 className="mb-0">
              <i className="bi bi-heart-fill me-2"></i>
              Dog Details
            </h5>
          </div>

          <div className="card-body">
            <div className="row g-3">

              <div className="col-md-4">
                <label className="form-label">
                  Dog Name <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="dogName"
                  className="form-control"
                  value={formData.dogName}
                  onChange={handleChange}
                  placeholder="Enter dog name"
                />
              </div>

              <div className="col-md-4">
                <label className="form-label">
                  Breed <span className="text-danger">*</span>
                </label>
                <select
                  name="breed"
                  className="form-select"
                  value={formData.breed}
                  onChange={handleChange}
                >
                  <option value="">Select Breed</option>
                  <option value="Labrador Retriever">
                    Labrador Retriever
                  </option>
                  <option value="German Shepherd">
                    German Shepherd
                  </option>
                  <option value="Golden Retriever">
                    Golden Retriever
                  </option>
                  <option value="Pug">Pug</option>
                  <option value="Rottweiler">Rottweiler</option>
                  <option value="Beagle">Beagle</option>
                  <option value="Pomeranian">Pomeranian</option>
                  <option value="Indie">Indian Pariah / Indie</option>
                  <option value="Other">Other</option>
                </select>
              </div>

              <div className="col-md-4">
                <label className="form-label">
                  Gender <span className="text-danger">*</span>
                </label>
                <select
                  name="gender"
                  className="form-select"
                  value={formData.gender}
                  onChange={handleChange}
                >
                  <option value="">Select Gender</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                </select>
              </div>

              <div className="col-md-4">
                <label className="form-label">
                  Date of Birth
                </label>
                <input
                  type="date"
                  name="dateOfBirth"
                  className="form-control"
                  value={formData.dateOfBirth}
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-4">
                <label className="form-label">Age</label>
                <input
                  type="text"
                  name="age"
                  className="form-control"
                  value={formData.age}
                  onChange={handleChange}
                  placeholder="e.g. 2 Years"
                />
              </div>

              <div className="col-md-4">
                <label className="form-label">Color</label>
                <input
                  type="text"
                  name="color"
                  className="form-control"
                  value={formData.color}
                  onChange={handleChange}
                  placeholder="e.g. Black / Brown"
                />
              </div>

              <div className="col-md-6">
                <label className="form-label">
                  Identification Mark
                </label>
                <input
                  type="text"
                  name="identificationMark"
                  className="form-control"
                  value={formData.identificationMark}
                  onChange={handleChange}
                  placeholder="Any special identification mark"
                />
              </div>

              <div className="col-md-6">
                <label className="form-label">
                  Microchip No.
                </label>
                <input
                  type="text"
                  name="microchipNo"
                  className="form-control"
                  value={formData.microchipNo}
                  onChange={handleChange}
                  placeholder="Enter microchip number"
                />
              </div>

            </div>
          </div>
        </div>

        {/* Vaccination */}
        <div className="card shadow-sm border-0 mb-4">
          <div className="card-header bg-warning">
            <h5 className="mb-0">
              <i className="bi bi-shield-check me-2"></i>
              Vaccination Details
            </h5>
          </div>

          <div className="card-body">
            <div className="row g-3">

              <div className="col-md-3">
                <label className="form-label">
                  Rabies Vaccinated
                </label>
                <select
                  name="rabiesVaccinated"
                  className="form-select"
                  value={formData.rabiesVaccinated}
                  onChange={handleChange}
                >
                  <option value="">Select</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
              </div>

              <div className="col-md-3">
                <label className="form-label">
                  Vaccination Date
                </label>
                <input
                  type="date"
                  name="vaccinationDate"
                  className="form-control"
                  value={formData.vaccinationDate}
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-3">
                <label className="form-label">
                  Certificate No.
                </label>
                <input
                  type="text"
                  name="certificateNo"
                  className="form-control"
                  value={formData.certificateNo}
                  onChange={handleChange}
                  placeholder="Certificate number"
                />
              </div>

              <div className="col-md-3">
                <label className="form-label">
                  Next Vaccination Due
                </label>
                <input
                  type="date"
                  name="nextVaccinationDate"
                  className="form-control"
                  value={formData.nextVaccinationDate}
                  onChange={handleChange}
                />
              </div>

            </div>
          </div>
        </div>

        {/* Registration */}
        <div className="card shadow-sm border-0 mb-4">
          <div className="card-header bg-info text-white">
            <h5 className="mb-0">
              <i className="bi bi-file-earmark-text me-2"></i>
              Registration Details
            </h5>
          </div>

          <div className="card-body">
            <div className="row g-3">

              <div className="col-md-4">
                <label className="form-label">
                  Registration Date
                </label>
                <input
                  type="date"
                  name="registrationDate"
                  className="form-control"
                  value={formData.registrationDate}
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-4">
                <label className="form-label">
                  Sterilized
                </label>
                <select
                  name="sterilized"
                  className="form-select"
                  value={formData.sterilized}
                  onChange={handleChange}
                >
                  <option value="">Select</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
              </div>

              <div className="col-md-4">
                <label className="form-label">
                  Purpose
                </label>
                <select
                  name="purpose"
                  className="form-select"
                  value={formData.purpose}
                  onChange={handleChange}
                >
                  <option value="">Select Purpose</option>
                  <option value="Pet">Pet</option>
                  <option value="Guard">Guard</option>
                  <option value="Breeding">Breeding</option>
                  <option value="Other">Other</option>
                </select>
              </div>

            </div>
          </div>
        </div>

        {/* Documents */}
        <div className="card shadow-sm border-0 mb-4">
          <div className="card-header bg-secondary text-white">
            <h5 className="mb-0">
              <i className="bi bi-paperclip me-2"></i>
              Documents
            </h5>
          </div>

          <div className="card-body">
            <div className="row g-3">

              <div className="col-md-4">
                <label className="form-label">
                  Owner ID Proof
                </label>
                <input
                  type="file"
                  name="ownerIdProof"
                  className="form-control"
                  accept=".pdf,.jpg,.jpeg,.png"
                  onChange={handleChange}
                />
                <small className="text-muted">
                  PDF/JPG/PNG
                </small>
              </div>

              <div className="col-md-4">
                <label className="form-label">
                  Vaccination Certificate
                </label>
                <input
                  type="file"
                  name="vaccinationCertificate"
                  className="form-control"
                  accept=".pdf,.jpg,.jpeg,.png"
                  onChange={handleChange}
                />
                <small className="text-muted">
                  PDF/JPG/PNG
                </small>
              </div>

              <div className="col-md-4">
                <label className="form-label">
                  Dog Photograph
                </label>
                <input
                  type="file"
                  name="dogPhoto"
                  className="form-control"
                  accept=".jpg,.jpeg,.png"
                  onChange={handleChange}
                />
                <small className="text-muted">
                  JPG/PNG only
                </small>
              </div>

            </div>
          </div>
        </div>

        {/* Declaration */}
        <div className="card shadow-sm border-0 mb-4">
          <div className="card-body">

            <div className="form-check">
              <input
                type="checkbox"
                name="declaration"
                id="declaration"
                className="form-check-input"
                checked={formData.declaration}
                onChange={handleChange}
              />

              <label
                className="form-check-label"
                htmlFor="declaration"
              >
                I hereby declare that the information provided above
                is true and correct to the best of my knowledge. I
                agree to comply with all applicable municipal rules
                and regulations regarding pet dog registration,
                vaccination and ownership.
              </label>
            </div>

          </div>
        </div>

        {/* Buttons */}
        <div className="card shadow-sm border-0">
          <div className="card-body d-flex justify-content-end gap-2">

            <button
              type="button"
              className="btn btn-secondary px-4"
              onClick={handleReset}
              disabled={loading}
            >
              <i className="bi bi-arrow-counterclockwise me-2"></i>
              Reset
            </button>

            <button
              type="submit"
              className="btn btn-primary px-4"
              disabled={loading}
            >
              {loading ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                  ></span>
                  Saving...
                </>
              ) : (
                <>
                  <i className="bi bi-save me-2"></i>
                  Submit Registration
                </>
              )}
            </button>

          </div>
        </div>

      </form>
    </div>
  );
}

export default DogRegistration;